module.exports = __webpack_public_path__ + "img/xiangmufuwu.9f6080f1.png";